import * as React from "react";
import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { FormControl, Grid, InputLabel, Select } from "@mui/material";


export default function UnitMetaDataEditForm({unitRent, handleChangeUnitRent, rentCycle, handleChangeRentCycle, changeReason, handleChangeReason, effectiveStartDate, handleChangeEffectiveStartDate, allowedEffectiveDates = {has_restriction: false, allowed_range: "Any date"}}) {
	const [dateError, setDateError] = useState("");

	// Revalidate when date or restriction changes from outside
	useEffect(() => {
		if (!effectiveStartDate) {
			setDateError("");
			return;
		}

		if (allowedEffectiveDates?.has_restriction && allowedEffectiveDates?.payment_day) {
			const date = new Date(effectiveStartDate);
			const dayOfMonth = date.getDate();
			
			if (dayOfMonth !== allowedEffectiveDates.payment_day) {
				setDateError(`Only the ${allowedEffectiveDates.payment_day}th of any month is allowed`);
			} else {
				setDateError("");
			}
		} else {
			setDateError("");
		}
	}, [effectiveStartDate, allowedEffectiveDates]);

	const validateAndHandleDateChange = (event) => {
		const selectedDate = event.target.value;
		
		// Always update the date value first
		handleChangeEffectiveStartDate(event);
		
		// Then validate and set error if needed
		if (!selectedDate) {
			setDateError("");
			return;
		}

		// If there's a restriction, validate the day of month
		if (allowedEffectiveDates?.has_restriction && allowedEffectiveDates?.payment_day) {
			const date = new Date(selectedDate);
			const dayOfMonth = date.getDate();
			
			if (dayOfMonth !== allowedEffectiveDates.payment_day) {
				setDateError(`Only the ${allowedEffectiveDates.payment_day}th of any month is allowed`);
			} else {
				setDateError("");
			}
		} else {
			setDateError("");
		}
	};

	const getHelperText = () => {
		if (dateError) {
			return dateError;
		}
		if (changeReason === "INCREASE" && allowedEffectiveDates?.has_restriction) {
			return allowedEffectiveDates.allowed_range || `Only the ${allowedEffectiveDates.payment_day}th of any month`;
		}
		return "";
	};

	return (
		<>
			<Grid container component="form" noValidate autoComplete="off" spacing={2} sx={{marginTop:"1px"}}>
				<Grid item xs={12} sm={6}>
					<TextField size="small" fullWidth value={unitRent} label="Unit Rent" onChange={handleChangeUnitRent} />
				</Grid>
				<Grid item xs={12} sm={6}>
					<FormControl fullWidth size="small">
						<InputLabel id="demo-simple-select-label">Unit Rent Cycle</InputLabel>
						<Select label="Unit Rent cycle" labelId="rental-type" id="rental-type-id" defaultValue={rentCycle} onChange={handleChangeRentCycle}>
								<MenuItem value="MONTHLY">MONTHLY</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={12} sm={6}>
					<FormControl fullWidth size="small">
						<InputLabel id="change-reason-label">Change Reason</InputLabel>
						<Select label="Change Reason" labelId="change-reason-label" id="change-reason-id" value={changeReason} onChange={handleChangeReason}>
								<MenuItem value="MISTAKE">MISTAKE</MenuItem>
								<MenuItem value="INCREASE">INCREASE</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				{changeReason === "INCREASE" && (
					<Grid item xs={12} sm={6}>
						<TextField 
							size="small" 
							fullWidth 
							label="Effective Start Date" 
							type="date" 
							InputLabelProps={{ shrink: true }} 
							value={effectiveStartDate} 
							onChange={validateAndHandleDateChange}
							error={!!dateError}
							helperText={getHelperText()}
						/>
					</Grid>
				)}
			</Grid>
		</>
	);
}